import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { LogOut, Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';

export function AppShell() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  async function handleLogout() {
    await signOut();
    navigate('/login');
  }

  return (
    <div className="flex h-screen overflow-hidden bg-bg-base">
      <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex flex-1 flex-col overflow-hidden min-w-0">

        {/* Top bar */}
        <header className="flex h-14 shrink-0 items-center justify-between border-b border-border bg-bg-surface px-4 gap-4">

          {/* Hamburger — mobile only */}
          <button
            onClick={() => setSidebarOpen(true)}
            className="md:hidden flex items-center justify-center h-8 w-8 rounded-sm text-text-secondary hover:text-text-primary hover:bg-bg-elevated transition-colors"
            aria-label="Abrir menu"
          >
            <Menu className="h-4 w-4" />
          </button>

          {/* Spacer on desktop (hamburger absent) */}
          <div className="hidden md:block" />

          {/* Right side — user + logout */}
          <div className="flex items-center gap-3">
            {user && (
              <div className="flex items-center gap-2.5">
                <div className="text-right hidden sm:block">
                  <p className="text-xs font-medium text-text-primary leading-none">{user.name}</p>
                  <p className="text-2xs text-text-muted capitalize mt-0.5">{user.role}</p>
                </div>
                <div className="flex h-7 w-7 items-center justify-center rounded-full border border-border bg-bg-elevated text-xs font-semibold text-text-secondary shrink-0">
                  {user.name ? user.name.charAt(0).toUpperCase() : '?'}
                </div>
              </div>
            )}
            <Button variant="ghost" size="icon" onClick={handleLogout} title="Sair">
              <LogOut className="h-3.5 w-3.5" />
            </Button>
          </div>
        </header>

        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
